import { Buffer } from 'buffer';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { META_COLLECT_API } from '../../../api';
import { useSigninContext } from '../../../context/AuthProviderPages/Signin';
import { Register } from '../../../types/Register';
import { REGISTER_PHOTO_LABELS } from '../../../utils/registerPhotoLabel';
import { LoadingData } from '../../LoadingData';
import { ModalInfoTemplete } from '../ModalInfoTemplete';
import {
  EmptyState,
  PhotoCard,
  PhotosGrid,
  TabButton,
  TabsContainer,
} from './styles';

interface ICollectItemPhotosModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  DFIDITEMCOLETA?: string | number;
}

interface IPhotoTab {
  type: string;
  label: string;
}

const PHOTO_TABS: IPhotoTab[] = Object.entries(REGISTER_PHOTO_LABELS).map(
  ([type, label]) => ({ type, label }),
);

export const CollectItemPhotosModal: React.FC<ICollectItemPhotosModalProps> = ({
  isOpen,
  onRequestClose,
  DFIDITEMCOLETA,
}) => {
  const { path } = useSigninContext();
  const [loading, setLoading] = useState(false);
  const [registers, setRegisters] = useState<Register[]>([]);
  const [activeTab, setActiveTab] = useState<string>(PHOTO_TABS[0].type);

  useEffect(() => {
    if (isOpen && DFIDITEMCOLETA && path) {
      setActiveTab(PHOTO_TABS[0].type);
      setLoading(true);
      META_COLLECT_API.get(
        `/registro/laboratorio?DFIDITEMCOLETA=${DFIDITEMCOLETA}`,
        { headers: { path } },
      )
        .then(({ data }) => {
          setRegisters(data.registros);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar as fotos dessa coleta.');
          setLoading(false);
        });
    } else {
      setRegisters([]);
    }
  }, [isOpen, DFIDITEMCOLETA, path]);

  const activeTabLabel =
    PHOTO_TABS.find(tab => tab.type === activeTab)?.label || '';
  const registersOfActiveTab = registers.filter(
    register => register.DFTIPOREGISTRO === activeTab,
  );

  return (
    <ModalInfoTemplete
      option="coleta-item"
      titleModal="Fotos da Coleta em Propriedade"
      closeModal={onRequestClose}
      isOpen={isOpen}
      compactHeader
      large
    >
      <TabsContainer>
        {PHOTO_TABS.map(tab => (
          <TabButton
            key={tab.type}
            type="button"
            $active={activeTab === tab.type}
            onClick={() => setActiveTab(tab.type)}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabsContainer>
      {loading && <LoadingData title="Carregando fotos..." />}
      {!loading && registersOfActiveTab.length === 0 && (
        <EmptyState>Nenhuma foto de {activeTabLabel} registrada.</EmptyState>
      )}
      {!loading && registersOfActiveTab.length > 0 && (
        <PhotosGrid>
          {registersOfActiveTab.map((register, index) => {
            const buffer =
              register.DFREGISTROIMAGEM &&
              Buffer.from(register.DFREGISTROIMAGEM.data).toString();
            return (
              <PhotoCard key={index}>
                <img
                  src={`data:image/jpeg;base64,${buffer}`}
                  alt={activeTabLabel}
                />
              </PhotoCard>
            );
          })}
        </PhotosGrid>
      )}
    </ModalInfoTemplete>
  );
};
